import { render, staticRenderFns } from "./PlansDetail.vue?vue&type=template&id=fa0e97aa"
import script from "./PlansDetail.vue?vue&type=script&lang=js"
export * from "./PlansDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports